export const BASE_URL       = 'https://cinemapediaapi.electronicvillage.org';
export const FACEBOOK_ID    = '313949859659435'
export const GOOGLE_ID      = '869373708241-108ij95m8q0poo7ont8h9sghaf6f1a48.apps.googleusercontent.com'
export const USER_HOST      = 'https://evusers.electronicvillage.org'
export const RECAPTCHA      = '6LeEz_0hAAAAALYs3I-jTE3dvdC6JNAWnnD1jUUK'
export const APP_ID         = '32'
export const QUIZ_API_URL   = 'https://evai.in/cinemapedia-quiz'
// JustWatch's GraphQL API only allows CORS from justwatch.com/localhost, so the
// browser can't call it directly from cinemapedia.net — this hits our own PHP
// host instead, which passes the request through to JustWatch server-side
// (see justwatchProxy.php on the API server; no CORS applies server-to-server).
export const JUSTWATCH_API_URL = `${BASE_URL}/justwatchProxy.php`
